import React from 'react';
import './style.css';

function Footer() {
  return <footer id="footer"><span>Paige Faure</span><span>© {new Date().getFullYear()} Paige Faure</span><a href="#about">Back to top ↑</a></footer>;
}

export default Footer;
